import { render } from "./VisiMisi.vue?vue&type=template&id=73472e29"
import script from "./VisiMisi.vue?vue&type=script&lang=js"
export * from "./VisiMisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__